import { useEffect, useState } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const matchReducedMotion = () =>
  typeof window.matchMedia === 'function'
    ? window.matchMedia(REDUCED_MOTION_QUERY)
    : null;

export const useReducedMotion = () => {
  const [isReduced, setIsReduced] = useState(
    () => matchReducedMotion()?.matches ?? false
  );

  useEffect(() => {
    const mediaQuery = matchReducedMotion();

    if (!mediaQuery) return undefined;

    const handleChange = (event: MediaQueryListEvent) =>
      setIsReduced(event.matches);

    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isReduced;
};
